module.exports = __webpack_public_path__ + "static/media/spinner.d057d55a.svg";